module.exports = __webpack_public_path__ + "img/graph-blue.e19a0269.svg";